import create from 'zustand'

export const useBStore = create((set) => ({
  bears: 0,
  increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),
  removeAllBears: () => set({ bears: 0 }),
}))

export const useStore = create(set => ({
  auth: false,
  cart_count: 0,
  clients: { page: 1, count: 1, filter: {} },
  tasks: { page: 1, count: 1, filter: {} },
  setClients: (text) =>
    set((state) => ({
      clients: text
    })),
  setTasks: (text) =>
    set((state) => ({
      tasks: text
    })),
  setAuth: (text) =>
    set((state) => ({
      auth: text
    })),

    setCount: (text) =>
    set((state) => ({
      cart_count: text
    })),
}));